// src/components/teaching/CoursesList.jsx
import React from 'react';

const CoursesList = () => {
  const courses = [
    {
      name: "Database (DB)",
      code: "COURSE2714",
      level: "BSc",
      institution: "ISEL",
      department: "DEETC",
      semester: "Fall 2026/2027",
    },
    {
      name: "Natural Processing Language (NLP)",
      code: "COURSE4373",
      level: "MSc",
      institution: "ISEL",
      department: "DEI",
      semester: "Fall 2026/2027",
    },
    {
      name: "Information System (SisInf)",
      code: "COURSE4175",
      level: "BSc",
      institution: "ISEL",
      department: "DEETC",
      semester: "Spring 2026/2027",
    },
    {
      name: "Big Data Engineering (BDE)",
      code: "COURSE4372",
      level: "MSc",
      institution: "ISEL",
      department: "DEI",
      semester: "Spring 2026/2027",
    },
    {
      name: "Data-Centric AI (DCAI)",
      code: "COURSE4509",
      level: "MSc",
      institution: "ISEL",
      department: "DEI",
      semester: "Spring 2026/2027",
    },
  ];

  const pastCourses = [
    {
      name: "Introduction to Information System (ISI)",
      code: "COURSE4168",
      level: "BSc",
      institution: "ISEL",
      department: "DEETC",
      semester: "Fall 2024/2025",
    },
    {
      name: "Large Scale Data Mining (LSDM)",
      level: "MSc",
      institution: "ISEL",
      department: "DEETC",
      semester: "Fall 2024/2025",
    },
  ];

  return (
    <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-sm">
      <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">Teaching</h2>
      <div className="grid gap-6">
        {courses.map((course, index) => (
          <div key={index} className="border-l-4 border-indigo-500 pl-4">
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
              {course.name} ({course.code})
            </h3>
            <p className="text-gray-600 dark:text-gray-300">
              {course.level} • {course.department} • {course.institution}
            </p>
            <p className="text-gray-500 dark:text-gray-400">{course.semester}</p>
          </div>
        ))}
      </div>

      <h3 className="text-xl font-bold text-gray-900 dark:text-white mt-8 mb-4">Past Courses</h3>
      <div className="grid gap-6">
        {pastCourses.map((course, index) => (
          <div key={index} className="border-l-4 border-gray-300 dark:border-gray-600 pl-4">
            <h3 className="text-lg font-semibold text-gray-700 dark:text-gray-300">
              {course.name}
            </h3>
            <p className="text-gray-600 dark:text-gray-300">
              {course.level} • {course.department} • {course.institution}
            </p>
            <p className="text-gray-500 dark:text-gray-400">{course.semester}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CoursesList;